// Factories
import { BaseLogicModuleFactory } from "../../base/factories/BaseLogicModuleFactory";
/** Factory class for modules in Web app */
export class WebLogicModuleFactory extends BaseLogicModuleFactory {
    getSuiteNavModuleProvider(dispatcher, services, stores, configProvider) {
        return () => this.loader.load(this.getLmBundleKey("suitenav"), () => import(/* webpackChunkName: "uno-suitenavmodule" */ "@ms/uno-logicmodules/lib/local/modules/suiteNav/SuiteNavModule"), (bundle) => new bundle.SuiteNavModule(dispatcher, this.loggers, services, stores, configProvider));
    }
}
